module.exports = __webpack_public_path__ + "HolidayCheck.png";